import * as React from "react";
import Button from "@mui/material/Button";
import {
  Dialog,
  Box,
  Typography,
  Stack,
  DialogContentText,
  DialogContent,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import Loader from "./../../components/Loader";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getBalance } from "../../asyncAction/asyncBalance";

import {
  isEmpty,
  getErrorString,
  checkExtension,
  hasPremium,
} from "../../constants/function";
import ApiService from "../../services/api-service";
import notifier from "../Notifier";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useTranslation } from "react-i18next";
import { useTheme as useAppTheme } from "../../context/ThemeContext";
import LivestreamPayPopup from "../LivestreamPayPopup";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmPlayListNft(props) {
  const { t } = useTranslation("common");
  const { getCurrentBranding } = useAppTheme();
  const brandName = getCurrentBranding()?.appName || "SIKI";
  const [platform, setPlatform] = React.useState("Hedera");
  const dispatch = useDispatch();
  const [currency, setCurrecy] = React.useState("siki");
  const history = useHistory();
  const { bal, hbar } = useSelector((state) => state.balance);
  const [loading, setLoading] = React.useState(false);
  const [amount, setAmount] = React.useState(0);
  const [inUsd, setInUsd] = React.useState(null);
  const [charge, setCharge] = React.useState({});
  const [discountString, setDiscountString] = React.useState("");
  const isPremium = hasPremium();
  const [confirm, setConfirm] = React.useState(false);
  const [totlaAmount, setTotlaAmount] = React.useState(0);
  const [sikiTokenCost, setSikiTokenCost] = React.useState(0);
  const [showAddSiki, setShowAddSiki] = React.useState(false);
  const [showBuyPopup, setShowBuyPopup] = React.useState(false);

  const buyTokensWithPaypal = async (purchaseAmount) => {
    try {
      setLoading(true);
      const response = await ApiService.PAYPALLINK({
        amount: purchaseAmount,
      });
      setLoading(false);
      if (response?.result?.links?.[1]?.href) {
        window.open(response.result.links[1].href, '_blank');
        setShowBuyPopup(false);
        props.handleClose(null, false);
      }
    } catch (error) {
      console.error('PayPal link error:', error);
      setLoading(false);
    }
  };

  const save = async () => {
    // Check if user has sufficient balance - this shouldn't happen in save anymore
    if (bal < sikiTokenCost) {
      setShowBuyPopup(true);
      return;
    }

    let createdPlaylist;
    try {
      setLoading(true);
      console.log('[CONFIRM PLAYLIST] props.form:', props["form"]);
      console.log('[CONFIRM PLAYLIST] file:', props["form"].file);
      console.log('[CONFIRM PLAYLIST] file type:', typeof props["form"].file);
      console.log('[CONFIRM PLAYLIST] file instanceof File:', props["form"].file instanceof File);

      const formData = new FormData();
      formData.append("title", props["form"]["title"]);
      formData.append("currency", currency);
      formData.append("private", props["form"] && props["form"]["private"] ? "true" : "false");
      formData.append("isExplicit", props?.data);
      if (props["form"]["description"]) {
        formData.append("description", props["form"]["description"]);
      }

      const fileField = checkExtension(props["form"].file["name"])[0] === "gif" ? "GIF" : "thumbnailImg";
      console.log('[CONFIRM PLAYLIST] Appending file to field:', fileField);
      formData.append(fileField, props["form"].file);

      console.log('[CONFIRM PLAYLIST] FormData entries:');
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      const response = await ApiService.CREATE_PLAYLIST(formData);
      createdPlaylist = response?.result;
      if (!createdPlaylist?._id) {
        throw new Error("Playlist creation failed");
      }

      const response1 = await ApiService.CREATE_PLAYLIST_NFT_V4({
        playlistId: createdPlaylist._id,
        currency: currency,
        private: false,
        platform: platform,
      });
      setLoading(false);
      notifier.success(t("notifier.success.toast11"));
      dispatch(getBalance());
      const playlistWithNft = {
        ...createdPlaylist,
        nftDetails: response1["result"],
      };
      props.handleClose(playlistWithNft, false);
    } catch (error) {
      if (createdPlaylist?._id) {
        try {
          await ApiService.DELETE_PLAYLIST(createdPlaylist._id);
        } catch (cleanupError) {
          console.error("Failed to rollback playlist", cleanupError);
        }
      }
      notifier.error(getErrorString(error));
      props.handleClose(null, true);
      setLoading(false);
    }
  };
  const handleChange = (event) => {
    calculate(event.target.value);
    setCurrecy(event.target.value);
    // if (event.target.value === "siki" && bal < parseInt(amount))
    //   notifier.info("You don't have sufficient SIKI tokens to create nft.");
    // if (event.target.value === "hbar" && hbar < parseInt(amount))
    //   notifier.info("You don't have sufficient HBar tokens to create nft.");
  };
  const getChanges = async () => {
    try {
      const response = await ApiService.CHARGES();
      if (response["result"]) {
        setCharge({ ...response["result"] });
        setInUsd(1 / response["result"]["rate"]);
        let discount =
          (response["result"]["sikiOff"] / 100) *
          response["result"]["playlistNFT"];

        if (isPremium)
          discount =
            discount +
            (response["result"]["premiumOffPlaylist"] / 100) *
              response["result"]["playlistNFT"];
        const total = response["result"]["playlistNFT"] - discount;
        setSikiTokenCost(total);
        const premiumOffPlaylist = isPremium
          ? `${response["result"]["premiumOffPlaylist"]}% ${t("off")} +`
          : "";
        setDiscountString(
          `${response["result"]["playlistNFT"]} + ${premiumOffPlaylist}  ${
            response["result"]["sikiOff"]
          }% ${t("off")} = ${total} ${brandName} Coins`
        );
        setTotlaAmount(
          `${total.toFixed(2)} ${brandName} tokens ${t("nftPopup.text10")}`
        );
        // setAmount(total * response["result"]["rate"]);
        setAmount(
          response["result"]["playlistNFT"] * response["result"]["rate"]
        );
      }
    } catch (error) {
      console.warn('[ConfirmPlaylistNft] Failed to fetch charges:', error);
    }
  };
  const calculate = async (currency) => {
    if (charge["playlistNFT"] && currency === "siki") {
      setInUsd(1 / charge["rate"]);
      let discount = (charge["sikiOff"] / 100) * charge["playlistNFT"];

      if (isPremium)
        discount =
          discount +
          (charge["premiumOffPlaylist"] / 100) * charge["playlistNFT"];
      const total = charge["playlistNFT"] - discount;
      const premiumOffPlaylist = isPremium
        ? `${charge["premiumOffPlaylist"]}% ${t("off")} +`
        : "";
      setDiscountString(
        `${charge["playlistNFT"]} + ${premiumOffPlaylist}  ${
          charge["sikiOff"]
        }% ${t("off")} = ${total} SIKI Coins`
      );
      setTotlaAmount(`${total.toFixed(2)} SIKI tokens ${t("nftPopup.text10")}`);
      // setAmount(total * charge["rate"]);
      setAmount(charge["playlistNFT"] * charge["rate"]);
    } else if (charge["playlistNFTInHbar"] && currency === "hbar") {
      setInUsd(1 / charge["hbarValueInUsd"]);
      let discount = 0;

      if (isPremium)
        discount =
          (charge["premiumOffPlaylist"] / 100) * charge["playlistNFTInHbar"];
      const total = charge["playlistNFTInHbar"] - discount;
      const premiumOffPlaylist = isPremium
        ? `+${charge["premiumOffPlaylist"]}% ${t("off")} `
        : "";
      setDiscountString(
        !isPremium
          ? `${charge["playlistNFTInHbar"].toFixed(2)} HBar Coins`
          : `${charge["playlistNFTInHbar"].toFixed(
              2
            )}  ${premiumOffPlaylist}= ${total.toFixed(2)} HBar Coins`
      );
      setTotlaAmount(`${total.toFixed(2)} Hbar tokens ${t("nftPopup.text10")}`);
      // setAmount(total * charge["hbarValueInUsd"]);
      setAmount(charge["playlistNFTInHbar"] * charge["hbarValueInUsd"]);
    }  else if (charge["playlistNFTInMatic"] && currency === "matic") {
      setInUsd(1 / charge["maticValueInUsd"]); 
      let discount = 0;

      if (isPremium)
        discount =
          (charge["premiumOffPlaylist"] / 100) * charge["playlistNFTInMatic"];
      const total = charge["playlistNFTInMatic"] - discount;
      const premiumOffPlaylist = isPremium
        ? `+${charge["premiumOffPlaylist"]}% ${t("off")} `
        : "";
      setDiscountString(
        !isPremium
          ? `${charge["playlistNFTInMatic"].toFixed(2)} MATIC Coins`
          : `${charge["playlistNFTInMatic"].toFixed(
              2
            )}  ${premiumOffPlaylist}= ${total.toFixed(2)} MATIC Coins`
      );
      setTotlaAmount(
        `${total.toFixed(2)} MATIC tokens ${t("nftPopup.text10")}`
      );
      // setAmount(total * charge["hbarValueInUsd"]);
      setAmount(charge["playlistNFTInMatic"] * charge["maticValueInUsd"]);
    } else {
      setInUsd(1 / charge["nearValueInUsd"]); 
      let discount = 0;

      if (isPremium)
        discount =
          (charge["premiumOffPlaylist"] / 100) * charge["playlistNFTInNear"]; 
      const total = charge["playlistNFTInNear"] - discount;
      const premiumOffPlaylist = isPremium
        ? `+${charge["premiumOffPlaylist"]}% ${t("off")} `
        : "";
      setDiscountString(
        !isPremium
          ? `${charge["playlistNFTInNear"].toFixed(2)} NEAR Coins`
          : `${charge["playlistNFTInNear"].toFixed(
              2
            )}  ${premiumOffPlaylist}= ${total.toFixed(2)} NEAR Coins`
      );
      setTotlaAmount(
        `${total.toFixed(2)} NEAR tokens ${t("nftPopup.text10")}`
      );
      // setAmount(total * charge["hbarValueInUsd"]);
      setAmount(charge["playlistNFTInNear"] * charge["nearValueInUsd"]);
    }
  };
  React.useEffect(() => {
    getChanges();
    dispatch(getBalance());
  }, []);

  const showConirm = () => {
    if (bal < sikiTokenCost) {
      setShowBuyPopup(true);
    } else {
      setConfirm(true);
    }
  };
  const handlePlatformChange = (event) => {
    setPlatform(event.target.value);
  };
  return (
    <div>
      <Dialog
        onBackdropClick={() => props.handleClose(false)}
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => props.handleClose(false)}
        PaperProps={{
          style: {
            backgroundColor: "#1E1E1E",
            boxShadow: "none",
            color: "#ffffff",
            borderRadius: 16,
            margin: "0",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        {confirm ? (
          <Stack style={{ backgroundColor: "#1E1E1E" }}>
            <DialogContent>
              <DialogContentText
                color="default"
                align="center"
                id="alert-dialog-slide-description"
              >
                {totlaAmount}
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                style={{ width: "150px", padding: "10px 45px !important" }}
                onClick={() => props.handleClose(null, false)}
                color="default"
              >
                {t("cancel")}
              </Button>
              <Button
                style={{ width: "150px", padding: "10px 45px !important" }}
                variant="contained"
                color="primary"
                onClick={save}
              >
                {t("confirm")}
              </Button>
            </DialogActions>
          </Stack>
        ) : (
          <Stack spacing={2} style={{ backgroundColor: "#1E1E1E", padding: "24px", minWidth: "450px" }}>
            <Stack spacing={2}>
              <Typography variant="h6" color="default" sx={{ fontWeight: 600, textAlign: "center" }}>
                Mint Playlist
              </Typography>

              <Stack spacing={1.5} sx={{ backgroundColor: "#2A2A2A", padding: "16px", borderRadius: "8px" }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography color="default" className="fs-14">
                    Name:
                  </Typography>
                  <Typography color="default" className="fs-14" sx={{ fontWeight: 600, textAlign: "right", maxWidth: "70%", wordBreak: "break-word" }}>
                    {props["form"]["title"]}
                  </Typography>
                </Stack>
                <Stack direction="row" justifyContent="space-between">
                  <Typography color="default" className="fs-14">
                    Cost:
                  </Typography>
                  <Typography color="default" className="fs-14" sx={{ fontWeight: 600 }}>
                    {sikiTokenCost ? sikiTokenCost.toFixed(2) : '0'} {brandName} Coins
                  </Typography>
                </Stack>
                <Stack direction="row" justifyContent="space-between">
                  <Typography color="default" className="fs-14">
                    Your Balance:
                  </Typography>
                  <Typography
                    className="fs-14"
                    sx={{
                      color: bal >= sikiTokenCost ? "#4CAF50" : "#F48706",
                      fontWeight: 600
                    }}
                  >
                    {bal.toFixed(2)} {brandName} Coins
                  </Typography>
                </Stack>
              </Stack>
            </Stack>

            <DialogActions sx={{ justifyContent: "space-between", padding: 0 }}>
              <Button
                sx={{ maxWidth: "150px", padding: "10px 35px" }}
                color="default"
                onClick={() => props.handleClose(null, false)}
              >
                {t("cancel")}
              </Button>
              <Button
                sx={{ maxWidth: "150px", padding: "10px 35px" }}
                color="primary"
                variant="contained"
                onClick={showConirm}
              >
                {bal < sikiTokenCost ? "BUY SIKI" : t("continue")}
              </Button>
            </DialogActions>
          </Stack>
        )}
      </Dialog>
      <LivestreamPayPopup
        open={showBuyPopup}
        handleClose={() => setShowBuyPopup(false)}
        handleSubmit={(purchaseAmount) => {
          buyTokensWithPaypal(purchaseAmount);
        }}
        loading={loading}
        onlyPayPal={true}
        minSikiNeeded={sikiTokenCost}
      />
      {loading ? <Loader /> : null}
    </div>
  );
}
